import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  Flex,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Icon,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  useDisclosure,
  useToast,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Spinner,
  Text,
  Badge,
  IconButton,
  Tooltip,
  Select,
  HStack,
  VStack,
  InputGroup,
  InputLeftElement,
  Card,
  CardBody,
  CardHeader,
  Container,
  TableContainer
} from "@chakra-ui/react";
import { jwtDecode } from "jwt-decode";

// Ícone para placas na whitelist
const WhitelistIcon = (props) => (
  <Box as="svg" viewBox="0 0 24 24" mr={2} {...props}>
    <path
      fill="currentColor"
      d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,5A3,3 0 0,1 15,8A3,3 0 0,1 12,11A3,3 0 0,1 9,8A3,3 0 0,1 12,5M17.13,17C15.92,18.85 14.11,20.24 12,20.92C9.89,20.24 8.08,18.85 6.87,17C6.53,16.5 6.24,16 6,15.47C6,13.82 8.71,12.47 12,12.47C15.29,12.47 18,13.79 18,15.47C17.76,16 17.47,16.5 17.13,17Z"
    />
  </Box>
);

// Ícone para adicionar
const AddIcon = (props) => (
  <Box as="svg" viewBox="0 0 24 24" mr={2} {...props}>
    <path
      fill="currentColor"
      d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
    />
  </Box>
);

// Ícone para remover
const RemoveIcon = (props) => (
  <Box as="svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"
    />
  </Box>
);

// Ícone para refresh
const RefreshIcon = (props) => (
  <Box as="svg" viewBox="0 0 24 24" mr={2} {...props}>
    <path
      fill="currentColor"
      d="M17.65,6.35C16.2,4.9 14.21,4 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20C15.73,20 18.84,17.45 19.73,14H17.65C16.83,16.33 14.61,18 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6C13.66,6 15.14,6.69 16.22,7.78L13,11H20V4L17.65,6.35Z"
    />
  </Box>
);

// Ícone para editar
const EditIcon = (props) => (
  <Box as="svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z"
    />
  </Box>
);

// Ícone de pesquisa
const SearchIcon = (props) => (
  <Box as="svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
    />
  </Box>
);

// Ícone de próxima página
const NextPageIcon = (props) => (
  <Box as="svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"
    />
  </Box>
);

// Ícone de página anterior
const PrevPageIcon = (props) => (
  <Box as="svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z"
    />
  </Box>
);

// Componente de tab para Whitelist
const WhitelistTab = () => {
  const [allPlates, setAllPlates] = useState([]);
  const [displayedPlates, setDisplayedPlates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newPlate, setNewPlate] = useState("");
  const [description, setDescription] = useState("");
  const [plateToRemove, setPlateToRemove] = useState(null);
  const [plateToEdit, setPlateToEdit] = useState(null);
  const [editDescription, setEditDescription] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  
  // Estados para paginação
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [totalPages, setTotalPages] = useState(0);
  
  // Modal para adicionar placa
  const { isOpen, onOpen, onClose } = useDisclosure();
  
  // Modal para confirmar remoção
  const { 
    isOpen: isAlertOpen, 
    onOpen: onAlertOpen, 
    onClose: onAlertClose 
  } = useDisclosure();
  
  // Modal para editar placa
  const { 
    isOpen: isEditOpen, 
    onOpen: onEditOpen, 
    onClose: onEditClose 
  } = useDisclosure();
  
  const cancelRef = useRef();
  const toast = useToast();

  // Função para obter o ID do usuário do token
  const getUserIdFromToken = () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return null;
      
      const decodedToken = jwtDecode(token);
      return decodedToken.id || decodedToken.userId || null;
    } catch (error) {
      console.error("Erro ao decodificar token:", error);
      return null;
    }
  };

  useEffect(() => {
    fetchWhitelistPlates();
  }, []);

  useEffect(() => {
    // Filtra as placas com base no termo de pesquisa
    const filteredPlates = searchTerm
      ? allPlates.filter(
          plate => 
            plate.plate.toLowerCase().includes(searchTerm.toLowerCase()) ||
            (plate.description && plate.description.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (plate.addedBy && plate.addedBy.username.toLowerCase().includes(searchTerm.toLowerCase()))
        )
      : [...allPlates];

    // Calcula o número total de páginas
    const totalPagesCount = Math.ceil(filteredPlates.length / itemsPerPage);
    setTotalPages(totalPagesCount);

    // Garante que a página atual é válida
    const validCurrentPage = Math.min(currentPage, totalPagesCount || 1);
    if (validCurrentPage !== currentPage) {
      setCurrentPage(validCurrentPage);
    }

    // Calcula os índices de início e fim para a página atual
    const startIndex = (validCurrentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    // Atualiza as placas exibidas
    setDisplayedPlates(filteredPlates.slice(startIndex, endIndex));
  }, [allPlates, currentPage, itemsPerPage, searchTerm]);

  // Obter placas da whitelist
  const fetchWhitelistPlates = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const userId = getUserIdFromToken();
      
      if (!userId) {
        toast({
          title: "Erro de autenticação",
          description: "Sua sessão pode ter expirado. Por favor, faça login novamente.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setLoading(false);
        return;
      }
      
      const response = await fetch(`/api/whitelist?userId=${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });

      if (response.ok) {
        const data = await response.json();
        setAllPlates(data);
      } else {
        console.error("Erro ao buscar placas da whitelist");
        toast({
          title: "Erro",
          description: "Não foi possível carregar as placas da whitelist",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Erro:", error);
      toast({
        title: "Erro",
        description: "Ocorreu um erro ao se comunicar com o servidor",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  // Navegação de páginas
  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Adicionar placa à whitelist
  const addPlateToWhitelist = async () => {
    if (!newPlate) {
      toast({
        title: "Atenção",
        description: "Informe a placa a ser adicionada",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const userId = getUserIdFromToken();
      
      if (!userId) {
        toast({
          title: "Erro de autenticação",
          description: "Sua sessão pode ter expirado. Por favor, faça login novamente.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      const response = await fetch("/api/whitelist", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          plate: newPlate,
          description: description,
          userId: userId // Incluindo userId explicitamente
        }),
      });

      if (response.ok) {
        toast({
          title: "Sucesso",
          description: "Placa adicionada à whitelist com sucesso",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        setNewPlate("");
        setDescription("");
        onClose();
        fetchWhitelistPlates();
      } else {
        const errorData = await response.json();
        toast({
          title: "Erro",
          description: errorData.message || "Não foi possível adicionar a placa",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Erro:", error);
      toast({
        title: "Erro",
        description: "Ocorreu um erro ao se comunicar com o servidor",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Abrir modal de edição de placa
  const openEditPlateModal = (plate) => {
    setPlateToEdit(plate);
    setEditDescription(plate.description || "");
    onEditOpen();
  };

  // Atualizar descrição da placa
  const updatePlateDescription = async () => {
    try {
      const token = localStorage.getItem("token");
      const userId = getUserIdFromToken();
      
      if (!userId) {
        toast({
          title: "Erro de autenticação",
          description: "Sua sessão pode ter expirado. Por favor, faça login novamente.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }
      
      const response = await fetch(`/api/whitelist/${plateToEdit.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          description: editDescription,
          userId: userId
        }),
      });

      if (response.ok) {
        const data = await response.json();
        toast({
          title: "Sucesso",
          description: "Descrição da placa atualizada com sucesso",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        onEditClose();
        fetchWhitelistPlates();
      } else {
        const errorData = await response.json();
        toast({
          title: "Erro",
          description: errorData.message || "Não foi possível atualizar a placa",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Erro:", error);
      toast({
        title: "Erro",
        description: "Ocorreu um erro ao se comunicar com o servidor",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Verificar se uma placa está na whitelist
  const checkPlateInWhitelist = async (plate) => {
    try {
      const token = localStorage.getItem("token");
      const userId = getUserIdFromToken();
      
      if (!userId) {
        console.error("Erro de autenticação: Token inválido ou expirado");
        return false;
      }
      
      const response = await fetch(`/api/whitelist/check/${plate}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        return data.inWhitelist;
      }
      return false;
    } catch (error) {
      console.error("Erro ao verificar placa na whitelist:", error);
      return false;
    }
  };

  // Confirmar remoção de placa
  const confirmRemovePlate = (plate) => {
    setPlateToRemove(plate);
    onAlertOpen();
  };

  // Remover placa da whitelist
  const removePlateFromWhitelist = async () => {
    try {
      const token = localStorage.getItem('token');
      const userId = getUserIdFromToken();
      
      if (!userId) {
        toast({
          title: "Erro de autenticação",
          description: "Sua sessão pode ter expirado. Por favor, faça login novamente.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }
      
      const response = await fetch(`/api/whitelist/${plateToRemove.id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ userId: userId })
      });

      if (response.ok) {
        toast({
          title: "Sucesso",
          description: "Placa removida da whitelist com sucesso",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        fetchWhitelistPlates();
      } else {
        const errorData = await response.json();
        toast({
          title: "Erro",
          description: errorData.message || "Não foi possível remover a placa",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error('Erro:', error);
      toast({
        title: "Erro",
        description: "Ocorreu um erro ao se comunicar com o servidor",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      onAlertClose();
      setPlateToRemove(null);
    }
  };

  // Formatar data
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleString("pt-BR");
  };

  // Renderizar controles de paginação
  const renderPagination = () => {
    if (totalPages <= 1) return null;
    
    // Criar array com números das páginas a serem exibidas
    const pageNumbers = [];
    const maxPagesToShow = 5;
    
    if (totalPages <= maxPagesToShow) {
      // Se houver poucas páginas, mostrar todas
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Caso contrário, mostrar algumas páginas com elipses
      if (currentPage <= 3) {
        // Início da lista
        for (let i = 1; i <= 4; i++) {
          pageNumbers.push(i);
        }
        pageNumbers.push("...");
        pageNumbers.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        // Final da lista
        pageNumbers.push(1);
        pageNumbers.push("...");
        for (let i = totalPages - 3; i <= totalPages; i++) {
          pageNumbers.push(i);
        }
      } else {
        // Meio da lista
        pageNumbers.push(1);
        pageNumbers.push("...");
        pageNumbers.push(currentPage - 1);
        pageNumbers.push(currentPage);
        pageNumbers.push(currentPage + 1);
        pageNumbers.push("...");
        pageNumbers.push(totalPages);
      }
    }

    return (
      <HStack spacing={2} mt={4} justifyContent="center">
        <IconButton
          icon={<PrevPageIcon />}
          size="sm"
          onClick={goToPreviousPage}
          isDisabled={currentPage === 1}
          aria-label="Página anterior"
        />
        
        {pageNumbers.map((page, index) => (
          page === "..." ? (
            <Text key={`ellipsis-${index}`} px={2}>...</Text>
          ) : (
            <Button
              key={page}
              size="sm"
              colorScheme={currentPage === page ? "blue" : "gray"}
              onClick={() => goToPage(page)}
            >
              {page}
            </Button>
          )
        ))}
        
        <IconButton
          icon={<NextPageIcon />}
          size="sm"
          onClick={goToNextPage}
          isDisabled={currentPage === totalPages}
          aria-label="Próxima página"
        />
      </HStack>
    );
  };

  return (
    <Container maxW="container.xl" p={4}>
      <Card variant="outline" boxShadow="md" borderRadius="lg" overflow="hidden">
        <CardHeader bg="blue.50" py={4}>
          <Flex justify="space-between" align="center">
            <Heading size="md" display="flex" alignItems="center">
              <WhitelistIcon boxSize="6" />
              Placas na Whitelist
            </Heading>
            <Flex>
              <Button
                leftIcon={<RefreshIcon boxSize={4} />}
                mr={2}
                onClick={fetchWhitelistPlates}
                isLoading={loading}
                size="sm"
                colorScheme="gray"
              >
                Atualizar
              </Button>
              <Button
                leftIcon={<AddIcon boxSize={4} />}
                colorScheme="blue"
                onClick={onOpen}
                size="sm"
              >
                Adicionar Placa
              </Button>
            </Flex>
          </Flex>
        </CardHeader>
        <CardBody p={4}>
          <VStack spacing={4} align="stretch">
            {/* Filtros e opções */}
            <Flex 
              direction={{ base: "column", md: "row" }} 
              justify="space-between" 
              align={{ base: "stretch", md: "center" }}
              gap={3}
            >
              <InputGroup maxWidth={{ base: "100%", md: "300px" }}>
                <InputLeftElement pointerEvents="none">
                  <SearchIcon color="gray.400" boxSize={5} />
                </InputLeftElement>
                <Input
                  placeholder="Buscar placa, descrição ou usuário"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1);
                  }}
                />
              </InputGroup>
              <HStack spacing={2}>
                <Text fontSize="sm" whiteSpace="nowrap">Itens por página:</Text>
                <Select 
                  size="sm" 
                  width="70px"
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(Number(e.target.value));
                    setCurrentPage(1);
                  }}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                </Select>
              </HStack>
            </Flex>

            {/* Indicador de carregamento */}
            {loading ? (
              <Flex justify="center" align="center" height="200px">
                <Spinner size="xl" color="blue.500" thickness="4px" speed="0.65s" />
              </Flex>
            ) : allPlates.length === 0 ? (
              <Box textAlign="center" p={6} borderWidth="1px" borderRadius="md" bg="gray.50">
                <Text>Nenhuma placa na whitelist. Adicione placas para que não gerem infrações.</Text>
              </Box>
            ) : displayedPlates.length === 0 && searchTerm ? (
              <Box textAlign="center" p={6} borderWidth="1px" borderRadius="md" bg="gray.50">
                <Text>Nenhuma placa encontrada para "{searchTerm}".</Text>
              </Box>
            ) : (
              <>
                <TableContainer>
                  <Table variant="simple" colorScheme="gray" size="md">
                    <Thead bg="gray.50">
                      <Tr>
                        <Th>Placa</Th>
                        <Th>Descrição</Th>
                        <Th>Adicionada por</Th>
                        <Th>Data</Th>
                        <Th>Status</Th>
                        <Th>Ações</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {displayedPlates.map((plate) => (
                        <Tr key={plate.id}>
                          <Td fontWeight="bold">{plate.plate}</Td>
                          <Td>{plate.description || '-'}</Td>
                          <Td>{plate.addedBy ? plate.addedBy.username : 'Sistema'}</Td>
                          <Td>{formatDate(plate.created_at)}</Td>
                          <Td>
                            <Badge colorScheme={plate.active ? 'green' : 'red'} borderRadius="full" px={2}>
                              {plate.active ? 'Ativa' : 'Inativa'}
                            </Badge>
                          </Td>
                          <Td>
                            <Flex>
                              {plate.active && (
                                <Tooltip label="Editar descrição">
                                  <IconButton
                                    icon={<EditIcon boxSize={4} />}
                                    colorScheme="blue"
                                    size="sm"
                                    mr={2}
                                    aria-label="Editar placa"
                                    onClick={() => openEditPlateModal(plate)}
                                  />
                                </Tooltip>
                              )}
                              <Tooltip label="Remover da whitelist">
                                <IconButton 
                                  icon={<RemoveIcon boxSize={4} />} 
                                  colorScheme="red" 
                                  size="sm"
                                  aria-label="Remover da whitelist"
                                  onClick={() => confirmRemovePlate(plate)}
                                />
                              </Tooltip>
                            </Flex>
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </TableContainer>

                {/* Resumo e paginação */}
                <Flex 
                  direction={{ base: "column", md: "row" }} 
                  justify="space-between" 
                  align={{ base: "center", md: "center" }}
                  pt={4}
                  gap={2}
                >
                  <Text fontSize="sm" color="gray.600">
                    Exibindo {displayedPlates.length} de {allPlates.length} placas
                  </Text>
                  {renderPagination()}
                </Flex>
              </>
            )}
          </VStack>
        </CardBody>
      </Card>

      {/* Modal para adicionar placa */}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader bg="blue.50">Adicionar Placa à Whitelist</ModalHeader>
          <ModalCloseButton />
          <ModalBody p={5}>
            <FormControl mb={4} isRequired>
              <FormLabel>Placa</FormLabel>
              <Input 
                value={newPlate} 
                onChange={(e) => setNewPlate(e.target.value.toUpperCase())} 
                placeholder="AAA0000"
                maxLength={8}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Descrição</FormLabel>
              <Textarea 
                value={description} 
                onChange={(e) => setDescription(e.target.value)} 
                placeholder="Descreva por que esta placa está na whitelist"
                rows={4}
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Cancelar
            </Button>
            <Button colorScheme="blue" onClick={addPlateToWhitelist}>
              Adicionar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Modal para editar descrição da placa */}
      <Modal isOpen={isEditOpen} onClose={onEditClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader bg="blue.50">Editar Descrição da Placa</ModalHeader>
          <ModalCloseButton />
          <ModalBody p={5}>
            <FormControl mb={4} isReadOnly>
              <FormLabel>Placa</FormLabel>
              <Input 
                value={plateToEdit?.plate || ""} 
                placeholder="AAA0000"
                fontWeight="bold"
              />
            </FormControl>
            <FormControl>
              <FormLabel>Descrição</FormLabel>
              <Textarea 
                value={editDescription} 
                onChange={(e) => setEditDescription(e.target.value)} 
                placeholder="Descreva por que esta placa está na whitelist"
                rows={4}
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onEditClose}>
              Cancelar
            </Button>
            <Button colorScheme="blue" onClick={updatePlateDescription}>
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Dialog de confirmação para remover placa */}
      <AlertDialog
        isOpen={isAlertOpen}
        leastDestructiveRef={cancelRef}
        onClose={onAlertClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold" bg="red.50">
              Remover Placa da Whitelist
            </AlertDialogHeader>

            <AlertDialogBody py={4}>
              <Text>
                Tem certeza que deseja remover a placa <strong>{plateToRemove?.plate}</strong> da whitelist?
              </Text> 
              <Text mt={3}>
                Esta placa voltará a gerar infrações quando detectada.
              </Text>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onAlertClose}>
                Cancelar
              </Button>
              <Button colorScheme="red" onClick={removePlateFromWhitelist} ml={3}>
                Remover
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Container>
  );
};

export default WhitelistTab;
